export const AI_BANNER_VIDEO_URL =
    'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd_nl/v1/video-attachments/generic_asset/asset/b6a601a2026c52e7aa26820234cd24cc-1790758393435/AI%20Automation';

/** Static preview of the banner video, shown until the video loads */
export const AI_BANNER_POSTER_URL =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/c79180d6e4b83f7acb3daba69a43bd2a-1790758586435/AI%20Automation.png';

export const AI_BANNER_UTM_SOURCE = 'lohp_ai_automation_banner';
